/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit No/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import PendingCounter from './PendingCounter/index'
import React from 'react'
import TysiaIconTaskAlt from 'DesignSystem/Svgs/TysiaIconTaskAlt/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function No({
  children,
  viewPath = "/App/Account/Topbar/Tasks/No",
  onMouseEnter,
  onMouseLeave,
  hovered,
  selected
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.800'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  onMouseEnter,
  onMouseLeave,
  hovered,
  selected
  
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<button
  data-testid="No.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--ml-1-Fs': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-2-Fs': hovered ? dtColorsNeutral700 : selected ? dtColorsNeutral700 : dtColorsNeutral800}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaIconTaskAlt
  viewPath={`${viewPath}/TysiaIconTaskAlt`}
 width={16}
 height={16}
 fill={dtColorsWhite}
/>
<PendingCounter
  viewPath={`${viewPath}/PendingCounter`}
/>
</button>
{children}
</React.Fragment>)
}